import { SelectFormControl, type SelectFormControlProps } from 'BrokerTsLib/src/components'
import { useFormContext } from 'BrokerTsLib/src/rhf'

import { useGetOrganizationUnits, useGetUsers } from '@/hooks/useUser'

interface OrganizationUserFormControlsProps {
  showLabel?: boolean
  size?: 'sm' | 'md' | 'lg'
  variant?: SelectFormControlProps['variant']
  selectStyle?: SelectFormControlProps['sx']
}

/** A component which renders FormControls of OrganizationUnit and User with cross filtering. */
export const OrganizationUserFormControls = ({ showLabel = true, size = 'lg', variant, selectStyle }: OrganizationUserFormControlsProps) => {
  const { setValue, watch, control } = useFormContext()

  const ouId = watch('ouId') as number
  const userId = watch('userId') as string

  const { data: organizationUnits, isFetching: isFetchingOUs } = useGetOrganizationUnits()

  const { data: users, isFetching: isFetchingUsers } = useGetUsers(ouId)

  const onUserIdChanged = (newUserId: string) => {
    if (newUserId)
      setValue('ouId', users?.data.find((x) => x.userId === newUserId)?.ouId)
  }

  const onOuIdChanged = (newOuId: number) => {
    if (newOuId && users && !users?.data.some((x) => x.userId === userId))
      setValue('userId', '')
  }

  if ((organizationUnits?.data.length ?? 0) === 0) return null

  return (
    <>
      <SelectFormControl name='ouId' control={control} valueAsNumber
        label={showLabel ? 'Organizační jednotka' : undefined}
        options={
          organizationUnits?.data.map((ou) => ({
            value: ou.id.toString(),
            label: `${ou.name} ${ou.description}`,
          }))
        }
        unselectedText='Vyberte organizaci'
        onChange={(v) => onOuIdChanged(v as number)}
        isLoading={isFetchingOUs}
        size={size}
        variant={variant}
        sx={selectStyle}
      />

      <SelectFormControl name='userId' control={control}
        label={showLabel ? 'Uživatel' : undefined}
        options={
          users?.data.map((u) => ({
            value: u.userId!,
            label: `${u.surname} ${u.name} (${organizationUnits?.data?.find((x) => x.id.toString() === u.ouId?.toString())?.name}) ${u.ouDescription ?? ''}`,
          }))
        }
        unselectedText='Vyberte uživatele'
        onChange={(v) => onUserIdChanged(v as string)}
        isLoading={isFetchingUsers}
        size={size}
        variant={variant}
        sx={selectStyle}
      />
    </>
  )
}
